import React from 'react';
import PropTypes from 'prop-types';
import TextSelectField from '@/components/common/form/TextSelectField';
import ConstituentQueryTypeFields from '@/constants/constituents/ConstituentQueryTypeFields';
import ConstituentSortFields from '@/constants/constituents/ConstituentSortFields';
import SortOrder from '@/constants/SortOrder';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import useConstituentSearch from '@/lib/hooks/swr/useConstituentSearch';

const formatConstituent = (constituent) => {
  return {
    value: constituent.constituentId,
    icon: '',
    text: constituent.displayName,
    constituentType: constituent.constituentType,
    isAvatar: true,
  };
};

function ConstituentSearchField({
  classes = {},
  initialConstituentId = '',
  loading = false,
  params = {},
  setValue = () => {},
  value = null,
  ...rest
}) {
  const [nameEmailPhone, setNameEmailPhone] = React.useState('');
  const searchParams = React.useMemo(
    () => ({
      ...params,
      nameEmailPhone: nameEmailPhone || null,
      page: 1,
      pageSize: 24,
      queryType: ConstituentQueryTypeFields.SIMPLE,
      sortBy: ConstituentSortFields.DISPLAY_NAME,
      sortOrder: SortOrder.ASC,
    }),
    [nameEmailPhone, params],
  );

  const { data } = useConstituentSearch(searchParams);
  const { data: constituent, isValidating } =
    useConstituent(initialConstituentId);

  React.useEffect(() => {
    if (constituent) {
      setValue(formatConstituent(constituent));
    }
  }, [constituent, isValidating]);

  const onInputChange = (e) => {
    setNameEmailPhone(e?.target?.value || '');
  };

  const items = React.useMemo(
    () => data?.constituents.map(formatConstituent) || [],
    [data],
  );

  return (
    <TextSelectField
      filterOptions={TextSelectField.asyncFilterOptions}
      classes={classes}
      items={items}
      loading={
        loading ||
        isValidating ||
        !!(!initialConstituentId && !data) ||
        !!(initialConstituentId && !constituent)
      }
      value={value || null}
      inputValue={nameEmailPhone || ''}
      onInputChange={onInputChange}
      setValue={setValue}
      {...rest}
    />
  );
}

ConstituentSearchField.propTypes = {
  classes: PropTypes.shape({
    formControl: PropTypes.string,
    root: PropTypes.string,
    textField: PropTypes.string,
  }),
  initialConstituentId: PropTypes.string,
  params: PropTypes.object,
  loading: PropTypes.bool,
  setValue: PropTypes.func,
  value: PropTypes.shape({
    icon: PropTypes.string,
    isAvatar: PropTypes.bool,
    text: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default ConstituentSearchField;
